export default class Form {
	constructor (form) {
		this.form = form
	}

	get (key) {
		return this.form[key]
	}

	isNull (key) {
		return this.form[key] === null
	}

	isEmptyString (key) {
		return this.form[key].trim() === ''
	}

	keyCount () {
		return Object.key(this.form).length
	}

	getKeys () {
		return Object.key(this.form)
	}

	isFormInvalid (keys, dataType) {
		return keys.some(key => this.form[key] === dataType)
	}

	isMatch (value, confirmValue) {
		return this.form[value] === this.form[confirmValue]
	}

	isValidEmail (key) {
		const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

		return emailRegex.test(this.form[key])
	}
}
